import type { ButtonHTMLAttributes, ReactNode } from 'react';
import styles from './Button.module.css';

type Variant = 'primary' | 'secondary' | 'ghost' | 'danger';
type Size = 'small' | 'medium' | 'large';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  readonly variant?: Variant;
  readonly size?: Size;
  readonly block?: boolean;
  readonly children: ReactNode;
}

const SIZE_CLASS: Record<Size, string | undefined> = {
  small: styles.small,
  medium: undefined,
  large: styles.large,
};

export function Button({
  variant = 'secondary',
  size = 'medium',
  block = false,
  className,
  type = 'button',
  children,
  ...rest
}: ButtonProps) {
  const classes = [styles.button, styles[variant], SIZE_CLASS[size], block ? styles.block : undefined, className]
    .filter(Boolean)
    .join(' ');

  return (
    <button type={type} className={classes} {...rest}>
      {children}
    </button>
  );
}
